import Highcharts from "highcharts";
import moment from "moment";

const graficos = new Map();
const CONFIGS_SIZE = {
  ALTURA_HEADER: 60,
  ALTURA_PADRAO: 600,
  LARGURA_PADRAO: 1000,
};

const PERIODO_PERSONALIZADO = "personalizado";

export function adicionarGrafico(id, grafico, periodo, periodoGlobal, nomeCard, filtroAplicado) {
  let inicioGlobal;
  let fimGlobal;

  if (periodoGlobal?.data) {
    const ehPersonalizado = periodoGlobal.id === PERIODO_PERSONALIZADO;

    inicioGlobal = ehPersonalizado ? periodoGlobal?.data[0].format("YYYY-MM-DD") : periodoGlobal?.data[0];
    fimGlobal = ehPersonalizado ? periodoGlobal?.data[1].format("YYYY-MM-DD") : periodoGlobal?.data[1];
  } else {
    inicioGlobal = periodoGlobal[0];
    fimGlobal = periodoGlobal[1];
  }

  if (periodo[0] === inicioGlobal && periodo[1] === fimGlobal) {
    graficos.set(id, { grafico, periodoGlobal, nomeCard, filtroAplicado });
  }
}

export function resetarExportacaoGraficos() {
  graficos.clear();
}

export function obterTodosGraficos() {
  return Array.from(graficos.entries());
}

let exportLock = Promise.resolve();

export function gerarBase64(grafico) {
  exportLock = exportLock.then(
    () =>
      new Promise(resolve => {
        const downloadUrl = Highcharts.downloadURL;

        Highcharts.downloadURL = function download(url) {
          Highcharts.downloadURL = downloadUrl;
          resolve(url.split(",")[1]);
        };

        grafico.exportChartLocal({
          type: "image/png",
          filename: "grafico",
          sourceWidth: grafico.renderTo?.offsetWidth > 0 ? grafico.renderTo.offsetWidth : CONFIGS_SIZE.LARGURA_PADRAO,
          sourceHeight: grafico.renderTo?.offsetHeight > 0 ? grafico.renderTo.offsetHeight : CONFIGS_SIZE.ALTURA_PADRAO,
        });
      })
  );
  return exportLock;
}

export function gerarBase64SemDados(grafico, mensagem) {
  const canvas = document.createElement("canvas");
  canvas.width = CONFIGS_SIZE.LARGURA_PADRAO;
  canvas.height = CONFIGS_SIZE.ALTURA_PADRAO;

  const ctx = canvas.getContext("2d");

  ctx.fillStyle = "#fff";
  ctx.fillRect(0, 0, CONFIGS_SIZE.LARGURA_PADRAO, CONFIGS_SIZE.ALTURA_PADRAO);

  ctx.fillStyle = "#f5f5f5";
  ctx.fillRect(0, 0, CONFIGS_SIZE.LARGURA_PADRAO, CONFIGS_SIZE.ALTURA_HEADER);
  const meioHeader = CONFIGS_SIZE.ALTURA_HEADER / 2;

  ctx.fillStyle = "#333";
  ctx.font = "20px sans-serif";

  ctx.textAlign = "left";
  ctx.textBaseline = "middle";
  ctx.fillText(grafico.nomeCard, 20, meioHeader);

  if (grafico?.filtroAplicado) {
    ctx.textAlign = "center";
    ctx.fillText(grafico.filtroAplicado, CONFIGS_SIZE.LARGURA_PADRAO / 2, meioHeader);
  }

  let periodoInicio = "";
  let periodoFim = "";
  const periodo = grafico?.periodoGlobal;

  if (Array.isArray(periodo)) {
    periodoInicio = moment(periodo[0]).format("DD/MM/YYYY");
    periodoFim = moment(periodo[1]).format("DD/MM/YYYY");
  } else if (Array.isArray(periodo?.data)) {
    periodoInicio = moment(periodo.data[0]).format("DD/MM/YYYY");
    periodoFim = moment(periodo.data[1]).format("DD/MM/YYYY");
  }

  ctx.textAlign = "right";
  ctx.fillText(`${periodoInicio} - ${periodoFim}`, CONFIGS_SIZE.LARGURA_PADRAO - 20, meioHeader);

  ctx.fillStyle = "#999";
  ctx.font = "20px sans-serif";
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText(
    mensagem,
    CONFIGS_SIZE.LARGURA_PADRAO / 2,
    (CONFIGS_SIZE.ALTURA_PADRAO + CONFIGS_SIZE.ALTURA_HEADER) / 2
  );

  return canvas.toDataURL("image/png").split(",")[1];
}
